import styled from "styled-components";
import { HXIconButton } from "./HXButton";
import { colors } from "healthex-common/colors";
import Edit from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import { HXTextField as SharedHXTextField } from "./base.styles";
export const UserAvatarContainer = styled.div `
    justify-content: center;
    justify-items: center;
    position: relative;
    width: 80px;
    height: 80px;
`;
export const EditIcon = styled(Edit) `
    width: 24px;
    height: 24px;
`;
export const EditIconButton = styled(HXIconButton).attrs({ component: "label" }) `
    position: absolute;
    top: -7px;
    right: -7px;
    padding: 5px;
    background: ${colors.white_main};
    border: 1px solid ${colors.navy_50};

    &:hover {
        filter: drop-shadow(${colors.black_30} -2px 2px 3px);
        background: ${colors.white_background} !important;
    }
`;
export const UploadAvatarCircularProgress = styled(CircularProgress) `
    width: 32px !important;
    height: 32px !important;
    color: ${colors.navy_main};
    position: absolute;
    top: 24px;
    left: 24px;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    box-shadow: inset 0 0 0px 20px #ffffff44;
    background: transparent;
`;
export const HXTextField = styled(SharedHXTextField) `
    width: 360px;
`;
